import { render, staticRenderFns } from "./Seagull.vue?vue&type=template&id=5a918a3c&scoped=true&"
import script from "./Seagull.vue?vue&type=script&lang=js&"
export * from "./Seagull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a918a3c",
  null
  
)

export default component.exports